<ngx-material-popover [popoverContent]="popoverContent" [clickOutToClose]="true" [xPosition]="xPosition"
  [yPosition]="yPosition" [clickOutToClose]="true" #popover="ngxMaterialPopover" (onClose)="closedEvent($event)"
  mode="toggle">
  <button mat-raised-button>
    {{ dateRangeTitle }}
    <mat-icon class="expand">expand_more</mat-icon>
  </button>
</ngx-material-popover>

<ng-template #popoverContent>
  <mat-form-field style="width: 100%;">
    <mat-label>Select duration</mat-label>
    <mat-select
      [(ngModel)]="selectedDateFilterOption"
      (ngModelChange)="onDateFilterOptionChange()"
      >
      @for (option of dateFilterOptions; track option) {
        <mat-option [value]="option.value">
          {{ option.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  @if (selectedDateFilterOption === 'custom') {
    <mat-form-field>
      <mat-label>Select a date range</mat-label>
      <div class="date-range-class">
        <mat-date-range-input [rangePicker]="picker" name="dateRange">
          <input matStartDate placeholder="Start date" #dateRangeStart>
          <input matEndDate placeholder="End date" #dateRangeEnd (dateChange)="onCustomDateRangeChange(dateRangeStart.value, dateRangeEnd.value)">
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </div>
    </mat-form-field>
  }
</ng-template>
